/**
 * useProvisionalThreshold
 * 
 * Hook to fetch the shop's provisional add-on threshold from shop_culture settings.
 * Returns 0 by default (trigger on any increase).
 */

import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useProvisionalThreshold() {
  const [threshold, setThreshold] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadThreshold = async () => {
      try {
        const { data } = await supabase
          .from('shop_profile')
          .select('shop_culture')
          .limit(1)
          .single();
        
        const culture = data?.shop_culture as Record<string, unknown> | null;
        const optimizerSettings = culture?.optimizer_settings as Record<string, unknown> | null;
        const thresholdValue = optimizerSettings?.provisional_threshold_minutes as number | undefined;
        
        setThreshold(thresholdValue ?? 0);
      } catch (err) {
        console.error('Error loading provisional threshold:', err);
        setThreshold(0); // Default to triggering on any increase
      } finally {
        setIsLoading(false);
      }
    };

    loadThreshold();
  }, []);

  return { threshold, isLoading };
}
